import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { configOperations } from '../../../redux/config';
import { mapOperations } from '../../../redux/map';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RequiredFieldStatus from '../RequiredFieldStatus';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import MergeInfoDialog from './MergeInfoDialog';

import '../DetailsIncidentPanel.css';

class MergeInfoPanel extends Component {
  constructor(props) {

    super(props);
    this.state = {
      open: true,
      mergeInfoPanelOpen: false,
      activeMergeInfo: null,
      primaryRequiredNullFields: [],
      requiredNullFields: [],
      derivingFields: [],
      secondaryRequiredNullFields: [],
      totalRequiredNullFields: null,
      requiredFields: props.requiredFields ? props.requiredFields : [],
      staticFields: props.staticFields ? props.staticFields : [],
      attributes: props.attributes,
      dependentFields: props.dependentFields ? props.dependentFields : []
    };
  }


  //TODO: Try to get rid of all componentWillReceiveProps
  componentWillReceiveProps(nextProps) {

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields === 0)
   {
     this.setState({
       open: false
     });
   }

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields > 0)
   {
     this.setState({
       open: true
     });
   }

    if (nextProps.expandAllPanels === true)
    {
      this.setState({
        open: true
      });
    }


   if(nextProps.requiredFields && this.props.requiredFields)
   {
     if (JSON.stringify({...nextProps.requiredFields}) !== JSON.stringify({...this.state.requiredFields}))
     {
       this.updateRequiredFields(nextProps.requiredFields);

       if(nextProps.attributes && this.props.attributes)
       {
           //this.updateRequiredNullFields(nextProps.attributes, nextProps.requiredFields);
       }
     }
   }

  }

updateRequiredFields = (updatedRequiredFields) =>
{
  this.setState({
    requiredFields: updatedRequiredFields
  });
}

  highlightRequiredFields = () =>
  {
    const open = this.state.open || (this.state.secondaryRequiredNullFields.length > 0);
    this.setState({
      open,
      highlightRequiredFields: true
    }, () => {
      window.setTimeout(() => {
        this.setState({highlightRequiredFields: false})
      }, 1000);
    });
  }

  accordionChange = (event) =>
  {
    this.setState({open: !this.state.open});
    this.props.resetPanelCollapseFlag();
  }

  hideMergeInfo = () =>
    {
        //mergeInfoPanelOpen: false,
        //activeMergeInfo: null,

        this.setState(
            {
                mergeInfoPanelOpen: false,
                activeMergeInfo: null
            });
    }

  showMergeInfo = (mergedIncident) =>
    {
        debugger;
        //mergeInfoPanelOpen: false,
        //activeMergeInfo: null,

      this.setState(
        {
            mergeInfoPanelOpen: true,
            activeMergeInfo: mergedIncident
        });
    }

  render()
  {

    let requiredFieldStatusNode = '';
    if (this.state.totalRequiredNullFields > 0)
    {
      requiredFieldStatusNode = (
        <RequiredFieldStatus
          chipClicked={this.highlightRequiredFields}
          missingFields={this.state.totalRequiredNullFields} />
      )
    }

    let title = (
      <div className="incident-details-panel-header">
        <h4>{this.props.title}</h4>
        <span className="required-field-node-class">{requiredFieldStatusNode}</span>
      </div>
    )

    return (
      <Accordion className="incident-details-panel" expanded={this.state.open} onChange={this.accordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
        <AccordionDetails>
        <Table size="small">
                    <TableRow>
                        <TableCell><b>Name</b></TableCell>
                        <TableCell><b>Merge Date</b></TableCell>
                        <TableCell><b>Acres</b></TableCell>
                    </TableRow>
                <TableBody>
                    {this.props.mergedIncidents.map(mergedIncident => {
                        return (
                            <TableRow>
                                <TableCell><Button onClick={(e) => this.showMergeInfo(mergedIncident)}>{mergedIncident.IncidentName}</Button></TableCell>
                                <TableCell>{moment(mergedIncident.MergedOnDateTime).format("MM/DD/YYYY")}</TableCell>
                                <TableCell>{mergedIncident.IncidentSize}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
            <MergeInfoDialog
                open={this.state.mergeInfoPanelOpen}
                onRequestClose={this.hideMergeInfo}
                mergedIncident={this.state.activeMergeInfo} />
      </AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...configOperations,
    ...mapOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MergeInfoPanel)
